import { render, staticRenderFns } from "./superzoom-slide.vue?vue&type=template&id=dfaa1e0c&"
import script from "./superzoom-slide.vue?vue&type=script&lang=js&"
export * from "./superzoom-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports